import React from 'react';

export const CallLogsHeader = ({
    selectedDate,
    setSelectedDate,
    todayFormatted,
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    selectedStaff,
    setSelectedStaff,
    staffList = [],
    selectedDistrict,
    setSelectedDistrict,
    districtList = [],
    stats
}) => {
    return (
        <div className="p-3 border-bottom card-header bg-transparent">
            {/* Top Row: Title & Stats Badges */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div>
                    <h5 className="card-title mb-0 fs-16 fw-bold text-body d-flex align-items-center gap-2">
                        <i className="ri-phone-camera-line text-primary fs-18" />
                        Call Logs & Calling History
                    </h5>
                    <p className="text-muted fs-12 mb-0">
                        Daily calls made, conversation remarks, and next scheduled follow-up dates
                    </p>
                </div>

                {/* Summary Count Badges */}
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span className="badge bg-soft-primary text-primary fs-12 px-2.5 py-1 fw-semibold">
                        Total Calls: {stats.total}
                    </span>
                    <span className="badge bg-soft-warning text-warning fs-12 px-2.5 py-1 fw-semibold">
                        Pending Next: {stats.pending}
                    </span>
                    <span className="badge bg-soft-success text-success fs-12 px-2.5 py-1 fw-semibold">
                        Converted: {stats.completed}
                    </span>
                    {stats.notInterested > 0 && (
                        <span className="badge bg-soft-danger text-danger fs-12 px-2.5 py-1 fw-semibold">
                            Not Interested: {stats.notInterested}
                        </span>
                    )}
                </div>
            </div>

            {/* Bottom Row: Date Filter + Quick Buttons + Staff Filter + Status + Search */}
            <div className="row g-2 align-items-center">
                {/* 1. Date Picker & Quick Actions */}
                <div className="col-12 col-md-auto d-flex align-items-center gap-1.5 flex-wrap">
                    <span className="fs-12 text-muted fw-semibold text-nowrap">
                        <i className="ri-calendar-line me-1" />
                        Date:
                    </span>
                    <input
                        type="date"
                        className="form-control form-control-sm fs-12"
                        style={{ width: 'auto', minWidth: '135px' }}
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                    />
                    <button
                        type="button"
                        className={`btn btn-sm py-1 px-2 fs-11 ${selectedDate === todayFormatted ? 'btn-primary' : 'btn-soft-primary'}`}
                        onClick={() => setSelectedDate(todayFormatted)}
                    >
                        Today
                    </button>
                    {selectedDate && (
                        <button
                            type="button"
                            className="btn btn-sm btn-soft-secondary py-1 px-2 fs-11"
                            onClick={() => setSelectedDate('')}
                            title="Show all dates"
                        >
                            All Dates
                        </button>
                    )}
                </div>

                {/* 2. Staff Filter (User requested) */}
                <div className="col-12 col-sm-auto">
                    <select
                        className="form-select form-select-sm fs-12"
                        value={selectedStaff}
                        onChange={(e) => setSelectedStaff(e.target.value)}
                        style={{ minWidth: '135px' }}
                        title="Filter by calling staff"
                    >
                        <option value="all">All Staff Members</option>
                        {staffList.map((staff) => (
                            <option key={staff.id} value={staff.id}>
                                {staff.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* 3. District Filter (User requested) */}
                <div className="col-12 col-sm-auto">
                    <select
                        className="form-select form-select-sm fs-12"
                        value={selectedDistrict}
                        onChange={(e) => setSelectedDistrict(e.target.value)}
                        style={{ minWidth: '130px' }}
                        title="Filter by district"
                    >
                        <option value="all">All Districts</option>
                        {districtList.map((dist) => (
                            <option key={dist} value={dist}>
                                {dist}
                            </option>
                        ))}
                    </select>
                </div>

                {/* 4. Status Filter */}
                <div className="col-12 col-sm-auto">
                    <select
                        className="form-select form-select-sm fs-12"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        style={{ minWidth: '130px' }}
                    >
                        <option value="pending">Only Pending</option>
                        <option value="all">All Status</option>
                        <option value="completed">Completed / Converted</option>
                        <option value="deleted">Not Interested</option>
                    </select>
                </div>

                {/* 4. Search Bar */}
                <div className="col-12 col-md ms-auto">
                    <div className="position-relative">
                        <input
                            type="text"
                            className="form-control form-control-sm fs-12 ps-4"
                            placeholder="Search by school, principal, phone..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-2 text-muted fs-13" />
                        {searchTerm && (
                            <button
                                type="button"
                                className="btn btn-sm btn-link position-absolute top-50 end-0 translate-middle-y p-0 me-2 text-muted"
                                onClick={() => setSearchTerm('')}
                            >
                                <i className="ri-close-line fs-14" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CallLogsHeader;
